import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MAJOR_ARCANA, MINOR_ARCANA, type TarotCard } from '@yadviga/shared'
import { TarotCardImage } from '../../components/tarot/TarotCardImage'
import { CardLightbox } from '../../components/tarot/CardLightbox'
import { PageHeader } from '../../components/ui/PageHeader'
import { SectionHeader } from '../../components/ui/SectionHeader'

export function TarotCardsRoute() {
  const { t, i18n } = useTranslation()
  const lang = (i18n.language === 'en' ? 'en' : 'ru') as 'ru' | 'en'
  const [open, setOpen] = useState<TarotCard | null>(null)

  return (
    <div className="flex flex-col gap-6 pb-6">
      <PageHeader
        title={t('cards.title')}
        subtitle={t('cards.intro')}
        backTo="/tarot"
      />

      <section>
        <SectionHeader title={t('cards.major')} />
        <div className="grid grid-cols-3 gap-3 sm:grid-cols-4">
          {MAJOR_ARCANA.map((c) => (
            <button
              key={c.id}
              onClick={() => setOpen(c)}
              className="flex flex-col items-center gap-1 rounded-2xl bg-white/60 p-2 ring-1 ring-sage-200/60 transition active:scale-[0.98]"
            >
              <TarotCardImage cardId={c.id} size="sm" zoomable={false} />
              <span className="text-center text-xs font-serif text-sage-800 line-clamp-2">
                {lang === 'en' ? c.nameEn : c.nameRu}
              </span>
            </button>
          ))}
        </div>
      </section>

      <section>
        <SectionHeader title={t('cards.minor')} />
        <div className="grid grid-cols-3 gap-3 sm:grid-cols-4">
          {MINOR_ARCANA.map((c) => (
            <button
              key={c.id}
              onClick={() => setOpen(c)}
              className="flex flex-col items-center gap-1 rounded-2xl bg-white/60 p-2 ring-1 ring-sage-200/60 transition active:scale-[0.98]"
            >
              <TarotCardImage cardId={c.id} size="sm" zoomable={false} />
              <span className="text-center text-xs font-serif text-sage-800 line-clamp-2">
                {lang === 'en' ? c.nameEn : c.nameRu}
              </span>
            </button>
          ))}
        </div>
      </section>

      {open && (
        <CardLightbox
          card={open}
          reversed={false}
          imageUrl={`/cards/${open.imageKey}.webp`}
          onClose={() => setOpen(null)}
        />
      )}
    </div>
  )
}
